import {useLocation, useNavigate} from "react-router-dom";
import {useRecoilState} from "recoil";
import {signUpSessionState} from "../../../state/signup-session";
import {requestSignup, useFetchTermOfService} from "../../../api/signcard";
import {useEffect, useState} from "react";
import {useTosUpdater} from "../domain/tos-updater";
import {TermOfServiceInfoPage} from "./component/term-of-service-Info";
import {TermOfServiceMainPage} from "./component/term-of-service-main";
import Swal from "sweetalert2";
import {useSetUserSession} from "../../../state/user-session";

const AgreeTermOfServicePage = () => {
    const {state} = useLocation()
    const navigate = useNavigate()

    const [signUpSession, setSignUpSession] = useRecoilState(signUpSessionState)

    const [isLoading, termOfServices,] = useFetchTermOfService()
    const [tosUpdater, isValid] = useTosUpdater(termOfServices)

    const [selectedTos, setSelectedTos] = useState(null)

    // TODO: 약관 구현 후 제거
    const [login,] = useSetUserSession()

    useEffect( () => {

        //////////////////////////
        // TODO: 약관 구현 후 제거

        const temp = (async () => {
            if (state.cardUuid === undefined && signUpSession == null) {
                navigate("/not-found")
                return
            }

            if (signUpSession != null) {
                return
            }

            setSignUpSession({
                cardUuid: state.cardUuid,
                oauthProvider: state.oauthProvider,
                oauthAccessToken: state.oauthAccessToken,
                agreementTermsOfService: null,
            })


            const showFailureAlert = () => Swal.fire({
                title: '알 수 없는 오류가 발생했습니다.',
                text: '관리자에게 문의해주세요.',
                customClass: 'swal-alert',
                allowOutsideClick: false,
                confirmButtonText: '확인',
                confirmButtonColor: '#2D2D2D'
            })

            try {
                const tempSignupSession = {
                    cardUuid: state.cardUuid,
                    oauthProvider: state.oauthProvider,
                    oauthAccessToken: state.oauthAccessToken,
                    agreementTermsOfService: {},
                }
                await requestSignup(tempSignupSession)
                setSignUpSession(null)

                const [isLogin,] = await login(state.oauthProvider, state.oauthAccessToken)

                if (!isLogin) {
                    return Promise.reject(Error("가입 후 로그인 에러"))
                }

                navigate("/welcome", { state: { cardUuid: state.cardUuid } })
                return
            } catch (e) {
                await showFailureAlert()
            }
        })

        temp()
        //////////////////////////
    }, [])

    const resSetSelectedTos = () => setSelectedTos(null)

    if (isLoading) {
        return <></>
    }

    // if (selectedTos) {
    //     return <TermOfServiceInfoPage tos={selectedTos}
    //                                   agreeTos={tosUpdater.check}
    //                                   close={resSetSelectedTos}/>
    // }
    //
    // return <TermOfServiceMainPage termOfServices={termOfServices}
    //                               tosUpdater={tosUpdater}
    //                               canSignUp={isValid}
    //                               openTermOfService={setSelectedTos}
    //                               signUpSession={signUpSession}
    //                               setSignUpSession={setSignUpSession}/>
}

export default AgreeTermOfServicePage;
